import { render, staticRenderFns } from "./Form04_149.vue?vue&type=template&id=519a0bd8&scoped=true&"
import script from "./Form04_149.vue?vue&type=script&lang=js&"
export * from "./Form04_149.vue?vue&type=script&lang=js&"
import style0 from "./Form04_149.vue?vue&type=style&index=0&id=519a0bd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519a0bd8",
  null
  
)

export default component.exports